module.exports = __webpack_public_path__ + "static/media/comment4_2.fe75a1b8.png";